export const quantityInGrams={
    "GOLD":10,
    "SILVER ($)":31.1035,
    "GOLD ($)":31.1035,
    "INR (₹)":1,
    "SILVER":1000
}